<script setup lang="ts">
import CustomInput from '~/components/base/CustomInput.vue';
import Social from '~/components/menu/Social.vue';
import CustomSelect from '~/components/base/CustomSelect.vue';
import { SOCIAL_ITEMS_FORM } from '~/utils/social';

// Select options
const sourcesItems = [
  { value: 'friend/colleague', label: 'Recommendation from friend or colleague' },
  { value: 'social-media', label: 'Social media' },
  { value: 'google/search-engine', label: 'Google or other search engine' },
  { value: 'leaflet', label: 'Leaflet advert' },
  { value: 'other', label: 'Other' },
];

// Form fields
const form = reactive({
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
  clinic_name: '',
  attribution_source: '',
  referred_by: '',
});

const formSubmitted = ref(false);

// Submit
async function handleFormSubmit(values, { resetForm }) {
  await $fetch('/api/contact-form', {
    method: 'POST',
    body: form,
  }).then(() => {
    formSubmitted.value = true;
    resetForm();
  });
}
//
const { getTranslation } = useLanguage();

const { main: { touch } } = getTranslation();
</script>

<template>
  <section>
    <CommonContainer>
      <VeeForm
        class="bg-jungle-200 rounded-layout py-7 px-5 2xs:p-10 xs:pt-13 xs:px-16 xs:pb-16 sm:pt-15 sm:pb-20 sm:px-20"
        @submit="handleFormSubmit"
      >
        <h2 class="text-viola-600 font-semibold leading-default text-4xl 2xs:text-6xl sm:text-7xl hd:text-heading-xl">
          {{ touch.title.base }}
        </h2>
        <p class="text-viola-600 leading-default mt-3 text-lg 2xs:text-xl xs:text-2xl">
          {{ touch.title.extra }}
        </p>

        <div class="grid gap-4 mt-10 2xs:mt-14 xs:gap-10 xs:grid-cols-[1.6fr_1fr] sm:grid-cols-[1.25fr_1fr] sm:gap-15">
          <div class="grid gap-4">
            <div class="grid xs:grid-cols-2 gap-4 items-start">
              <!--   First name   -->
              <CustomInput
                v-model="form.first_name"
                rule="required"
                :label-options="{ text: touch.form.inputs.first_name }"
                :input-options="{
                  name: 'first_name',
                  type: 'text',
                }"
              />
              <!--   Last name   -->
              <CustomInput
                v-model="form.last_name"
                rule="required"
                :label-options="{
                  text: 'Last name',
                }"
                :input-options="{
                  name: 'last_name',
                  type: 'text',
                }"
              />
            </div>
            <!--   Email   -->
            <CustomInput
              v-model="form.email"
              rule="required|email"
              :label-options="{ text: touch.form.inputs.last_name }"
              :input-options="{
                name: 'email',
                type: 'email',
              }"
            />
            <!--   Phone number   -->
            <CustomInput
              v-model="form.phone_number"
              rule="required"
              :label-options="{ text: touch.form.inputs.contact_number }"
              :input-options="{
                name: 'phone_number',
                type: 'text',
              }"
            />
            <!--   Clinic name   -->
            <CustomInput
              v-model="form.clinic_name"
              rule="required"
              :label-options="{ text: touch.form.inputs.clinic_name }"
              :input-options="{
                name: 'clinic_name',
                type: 'text',
              }"
            />
            <!--   Where did you found us?   -->
            <CustomSelect
              v-model="form.attribution_source"
              rule="required"
              :label-options="{ text: touch.form.inputs.source }"
              :select-options="{
                name: 'attribution_source',
              }"
              :options="sourcesItems"
            />
          </div>

          <div class="flex flex-col">
            <!--   Referred by   -->
            <CustomInput
              v-model="form.referred_by"
              :label-options="{ text: touch.form.inputs.reference }"
              :input-options="{
                name: 'referred_by',
                type: 'text',
              }"
            />

            <BaseButton
              type="submit"
              class="mb-10 self-end mt-8 w-full min-w-[50%] 2xs:mb-6 2xs:w-auto xs:mt-6 xs:min-w-42.5 disabled:opacity-50 disabled:cursor-default"
              :disabled="formSubmitted"
            >
              {{ formSubmitted ? touch.form.buttons.submit.done : touch.form.buttons.submit.default }}
            </BaseButton>

            <div class="mt-auto flex flex-col items-center 2xs:items-end">
              <Social
                :items="SOCIAL_ITEMS_FORM"
                class="!gap-4"
                global-classes="!text-viola-600"
              />
              <BaseLink
                :link="`mailto:${ContactConfig.email}`"
                class="mt-4 font-semibold text-viola-600 !leading-default !text-xl xs:!text-2xl"
              >
                {{ ContactConfig.email }}
              </BaseLink>
            </div>
          </div>
        </div>
      </VeeForm>
    </CommonContainer>
  </section>
</template>
